// Dependêncies.
const axios = require('axios');
const axiosAdapter = require('axios/lib/adapters/http');

// Exports...
module.exports = {
    Axios: axios,
    AxiosAdapter: axiosAdapter
}